import queryString from "query-string";
import { router } from "./router.util";

export const searchTarget = {
  convertSearchTarget(searchCondition) {
    if (!searchCondition) {
      return {};
    }

    return {
      userUuid: searchCondition.userUuid,
      householdId: searchCondition.householdId,
      recordIds: searchCondition.recordIds,
      backQueryString: searchCondition.back
        ? `${router.getPath(searchCondition.back)}?${queryString.stringify({
            targetType: searchCondition.backTargetType,
            targetId: searchCondition.backTargetId
          })}`
        : null
    };
  },
  getBackInfoQueryStringFromTarget(target, extraBackInfo) {
    const { entity_type, uuid, household_id } = target || {};
    const isUserTarget = entity_type === "user";
    const backTargetType = isUserTarget ? "user" : "household";
    const backTargetId = isUserTarget ? uuid : household_id;
    const backQueryString = queryString.stringify({
      back: "GetConstructionTargetByProperty",
      backTargetType,
      backTargetId,
      ...(extraBackInfo || {})
    });

    return {
      backQueryString,
      backTargetType,
      backTargetId
    };
  }
};
